import { useMutation, useQueryClient } from "react-query";
import API from "../shared-utils/api";
export const useSubmitFeedback = () => {
    const queryClient = useQueryClient();
    return useMutation(async (payload) => {
        const { data } = await API.post("/api/v1/rbzo/reviews/experience/submit", payload);
        return data;
    }, {
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries(["recentPubBooking"]);
            queryClient.invalidateQueries(["userFeedbackHistory", String(variables.pubId)]);
            queryClient.invalidateQueries(["userFeedbackHistory", variables.pubId]);
        },
    });
};
